import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {BodyModule, GridModule, SharedModule} from '@progress/kendo-angular-grid';
import {InputsModule} from '@progress/kendo-angular-inputs';

import {GridContextMenuModule} from '../new-context-menu/context-menu.module';
import {GridColumnCellPipe} from './pipes/grid-column-cell.pipe';
import {GridColumnClassPipe} from './pipes/grid-column-class.pipe';
import {GridColumnStylePipe} from './pipes/grid-column-style.pipe';
import {GridDataSourceService} from './services/grid-data-source.service';
import {GridPagerService} from './services/grid-pager.service';
import {GridSelectorService} from './services/grid-selector.service';

@NgModule({
  declarations: [GridColumnCellPipe, GridColumnClassPipe, GridColumnStylePipe],
  imports: [
    BodyModule,
    ButtonsModule,
    CommonModule,
    GridModule,
    InputsModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    TranslateModule,
    SharedModule,
    GridContextMenuModule
  ],
  exports: [GridColumnCellPipe, GridColumnClassPipe],
  providers: [GridPagerService, GridSelectorService, GridDataSourceService]
})
export class CustomGridModule {}
